module.exports = __webpack_public_path__ + "static/media/shield.43c8fb44.svg";